export default "__VITE_ASSET__CPEnI19U__"